<app-prime-table
    #table
    class="table-component"
    queryParamProperty="finding"
    [data$]="findingsCurrentPage$"
    [rowsPerPage]="50"
    [columns]="columns()"
    [isLoading]="(isLoading$ | async) === true"
    (rowSelected)="rowSelected($event)"
    (rowUnselected)="rowUnselected()"
    [withCheckboxSelection]="false"
    [withActions]="false"
    [pageInfo]="pageInfo$.value"
    [sortedColumn$]="sortedColumn$"
    [tabelWithIcon]="false"
    tableNotFoundText="No issues found"
    tableNotFoundIcon="assets/images/common/no-results-found.svg"
/>
